<template>
  <div
    v-if="isDragging"
    class="absolute inset-0 z-50 bg-[var(--p-primary-color)]/10 backdrop-blur-sm flex items-center justify-center border-4 border-dashed border-[var(--p-primary-color)] pointer-events-none"
  >
    <div
      class="bg-[var(--p-surface-0)] dark:bg-[var(--p-surface-900)] rounded-2xl p-8 shadow-2xl flex flex-col items-center gap-4"
    >
      <div class="bg-[var(--p-primary-color)] rounded-full p-6">
        <Upload :size="48" class="text-white" />
      </div>
      <div class="text-center">
        <h3
          class="text-xl font-semibold text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)]"
        >
          Suelta tus archivos aquí
        </h3>
        <p class="text-sm text-[var(--p-surface-600)] dark:text-[var(--p-surface-400)] mt-1">
          Soporta imágenes, videos, documentos y más
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Upload } from 'lucide-vue-next'

interface Props {
  isDragging: boolean
}

defineProps<Props>()
</script>
